module.exports = __webpack_public_path__ + "img/rent_index_ad.890d579f.png";